<script>
    import {
        VpChevronBackwardIcon,
        VpCloseIcon,
    } from '@decathlon-experience/icons/svelte';

    import { FilterType } from '$saga/views/Search/types';
    import SelectFilter from '$saga/views/Search/Filters/SelectFilter.svelte';
    import PaxFilter from '$saga/views/Search/Filters/PaxFilter.svelte';
    import CalendarFilter from '$saga/views/Search/Filters/CalendarFilter.svelte';
    import FiltersSelection from '$saga/views/Search/Filters/FiltersSelection.svelte';
    import { filtersContext } from '$saga/views/Search/store';

    export let selectedFilterType,
        handleSelectedFilter,
        menuTitle,
        title,
        close,
        resetView;

    let selectedFilterComponentRef;
    let sectionRef;

    // method called by parent when melt-ui dialog is closed
    export const validateSelectionOnOutsideClick = () => {
        selectedFilterComponentRef?.validateSelection();
        resetView();
    };
</script>

<section class="flex h-full flex-col overflow-hidden">
    <!--HEADER -->
    <div
        class="sticky top-0 mx-l flex min-h-[65px] items-center justify-between border-b border-solid border-border-quiet bg-white px-l py-m desktop:px-3xl"
    >
        {#if selectedFilterType !== FilterType.SELECTION}
            <button on:click={() => handleSelectedFilter(FilterType.SELECTION)}>
                <span class="size-xl text-content-neutral">
                    <VpChevronBackwardIcon />
                </span>
            </button>
        {/if}
        <h2 class="font-semibold" {...$title} use:title>
            {menuTitle}
        </h2>
        <button
            {...$close}
            use:close
            aria-label="Close"
            on:click={() => resetView()}
        >
            <VpCloseIcon class="size-xl" />
        </button>
    </div>
    <!-- CONTENT -->
    <div
        bind:this={sectionRef}
        class="no-scrollbar flex flex-1 flex-col overflow-y-auto px-l desktop:px-3xl"
    >
        {#if selectedFilterType === FilterType.SELECTION}
            <FiltersSelection {handleSelectedFilter} />
        {:else if selectedFilterType === FilterType.SPORT}
            <SelectFilter
                bind:this={selectedFilterComponentRef}
                defaultList={$filtersContext.defaultSportOptions.filter(
                    (sport) => !sport.hidden,
                )}
                displayedList={$filtersContext.defaultSportOptions
                    .filter((sport) => sport?.depth !== 0 && !sport.hidden)
                    .sort((a, b) => a.label.localeCompare(b.label))}
                handleValidateSelection={() => {
                    resetView();
                }}
                bind:values={$filtersContext.formValues.theme}
                bind:labels={$filtersContext.formLabels.theme}
                placeholder="Rechercher un sport (surf, rando...)"
                allLabel="Voir tous les sports"
                enableAlphabeticalGrouping
            />
        {:else if selectedFilterType === FilterType.DESTINATION}
            <SelectFilter
                bind:this={selectedFilterComponentRef}
                defaultList={$filtersContext.defaultDestinationOptions.filter(
                    (desti) => !desti.hidden,
                )}
                displayedList={$filtersContext.defaultDestinationOptions.filter(
                    (dest) => dest?.depth === 0 && !dest.hidden,
                )}
                handleValidateSelection={() => {
                    resetView();
                }}
                bind:values={$filtersContext.formValues.destination}
                bind:labels={$filtersContext.formLabels.destination}
                placeholder="Rechercher un pays, une ville.."
                allLabel="Voir toutes les destinations"
                isSuggestion
            />
        {:else if selectedFilterType === FilterType.PAX}
            <PaxFilter
                bind:this={selectedFilterComponentRef}
                handleValidateSelection={(value) => {
                    $filtersContext.formValues.nbPax = value;
                    $filtersContext.formLabels.nbPax = value;
                    resetView();
                }}
            />
        {:else if selectedFilterType === FilterType.STARTDATE}
            <CalendarFilter
                bind:this={selectedFilterComponentRef}
                handleValidateSelection={() => {
                    resetView();
                }}
                overflowContainer={sectionRef}
            />
        {/if}
    </div>
</section>
